<template>
  <input
    ref="inputRef"
    type="text"
    :disabled="disabledFlag"
    @click="onClick"
    @blur="onBlur"
    @focus="onFocus"
  />
</template>

<script>
import { watch } from 'vue'
import { useCurrencyInput } from 'vue-currency-input'

export default {
  props: {
    value: Number,
    disabledFlag: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => ({
        currency: 'USD',
        precision: 0,
        currencyDisplay: 'hidden',
        // hideGroupingSeparatorOnFocus: false,
        valueRange: {
          min: 0,
          max: 999999999999999
          // max: 10
        },
        useGrouping: true
      })
    }
  },
  setup(props, { emit }) {
    const { inputRef, numberValue, setOptions, setValue } = useCurrencyInput(
      props.options
    )

    watch(
      () => props.value,
      value => {
        setValue(value)
      }
    )

    watch(
      () => props.options,
      options => {
        setOptions(options)
      }
    )

    watch(numberValue, value => {
      const { min, max } = props.options.valueRange
      const tmpValue = Math.min(Math.max(value, min), max)

      emit('input', tmpValue)
    })

    function onClick(e) {
      emit('click', e)
    }
    function onBlur(e) {
      emit('blur')
    }
    function onInput(e) {
      emit('input', numberValue.value)
    }

    function onFocus(e) {
      emit('focus')
    }

    return { inputRef, onClick, onBlur, onInput, onFocus }
  }
}
</script>
